var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-autocomplete',{attrs:{"maxlength":30,"clearable":"","placeholder":"请输入关键字","debounce":0,"fetch-suggestions":_vm.querySearch},on:{"select":function (item) {
      _vm.userTagName = item.value;
    },"input":_vm.change},model:{value:(_vm.userTagName),callback:function ($$v) {_vm.userTagName=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"userTagName"}})}
var staticRenderFns = []

export { render, staticRenderFns }